<template>
  <div class="df aic" style="padding: 30px 10px 0px">
    <span> {{ $t("langcfg.txtLamp") }}:&nbsp;&nbsp;</span>
    <el-radio-group v-model="SelectLight" @change="changeLight">
      <el-radio :label="true">{{ white }}</el-radio>
      <el-radio style="margin-left: 20px" :label="false">{{ infrared }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { saveCaptureSettings } from "../../../settings";
import { isDefined } from "../../../shared/utils";
export default {
  data() {
    return {
      white: this.$t("langcfg.txtWhiteLamp"),
      infrared: this.$t("langcfg.txtInfraredLamp"),
      SelectLight: false
    };
  },
  mounted() {
    if (isDefined(window.captureSettings.TearheightSelectLight)) {
      this.SelectLight = window.captureSettings.TearheightSelectLight;
    } else {
      window.captureSettings.TearheightSelectLight = false;
      saveCaptureSettings(window.captureSettings);
    }
  },
  methods: {
    changeLight(val) {
      window.captureSettings.TearheightSelectLight = val;
      saveCaptureSettings(window.captureSettings);
      this.$bus.$emit("camInit");
      this.$bus.$emit("lampInit", "tearheight");
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-radio {
  display: inline-flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/TearheightSetting.vue